module.exports = __webpack_public_path__ + "static/media/saba-sport.44809333.webp";